import SettingsIcon from '~/shared/assets/icons/settings.svg';
// import GridIcon from '~/shared/assets/icons/grid.svg';
// import AnalyticsIcon from '~/shared/assets/icons/analytics.svg';
import DashboardIcon from '~/shared/assets/icons/dashboard-icon.svg';
import ReportsIcon from '~/shared/assets/icons/reports.svg';

export const sidebarItems: SidebarItemType[] = [
  {
    title: 'Fleet Manager',
    icon: { el: DashboardIcon, colorMode: 'stroke' },
    pathname: '/fleet-manager',
  },
  {
    title: 'Reports',
    icon: { el: ReportsIcon },
    pathname: '/reports',
  },
  {
    title: 'Settings',
    icon: { el: SettingsIcon, colorMode: 'stroke' },
    pathname: '/settings',
    subItems: [
      { title: 'Permissions', pathname: '/settings/permissions' },
      { title: 'Configurations', pathname: '/settings/configurations' },
    ],
  },
];

export type SidebarSubItemType = {
  title: string;
  pathname: string;
};

export type SidebarItemType = {
  title: string;
  icon: { el: typeof DashboardIcon; colorMode?: 'stroke' | 'fill' };
  pathname: string;
  isDisabed?: boolean;
  subItems?: SidebarSubItemType[];
};
